import { NavLink, useLocation } from 'react-router-dom';

const ReportNavBar = () => {
    const { pathname } = useLocation();

    const isCenterMenuActive =
        pathname.includes("/center-performance-report") ||
        pathname.includes("/agent-performance-report") ||
        pathname.includes("/center-delivery-band") ||
        pathname.includes("/online-media-reports") ||
        pathname.includes("/center-ticket-size"); 

    return (
        <div className="page-wrapper mb-2">
            <div className="reportdiv">
                <ul className='reportlink'>
                    {/* Management Reports Mega Menu */}
                    <li className={`btnreport center-menu ${isCenterMenuActive ? "parent-active" : ""}`}>
                        <span className="center-menu-label">Management Reports ▾</span>
                        <ul className="center-submenu">
                            <li>
                                <NavLink to="/center-performance-report"
                                    className={({ isActive }) => `center-submenu-link ${isActive ? 'center-submenu-link--active' : ''}`}>
                                    Center Performance
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/agent-performance-report"
                                    className={({ isActive }) => `center-submenu-link ${isActive ? 'center-submenu-link--active' : ''}`}>
                                    Agent Performance
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/online-media-reports"
                                    className={({ isActive }) => `center-submenu-link ${isActive ? 'center-submenu-link--active' : ''}`}>
                                    Online/Media
                                </NavLink>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default ReportNavBar;
